import * as types from '../../actions/actionTypes';
import {LOOK_OVERLAYS} from "../look/core/constants";
import {IS_QKB_UI} from "../../config";
import {getExportAIData} from "./aiFunctions";
import {setLocalStorageItem} from "../../misc/storageFunctions";

const initialState = {
  aiLoading: false,
  // aiResult: {
  //   firstPrompt: "You are given several reference images.\n\nEach image corresponds to a specific kitchen feature, in the exact order listed below:\n\n1. Backsplash\r\n2. Center Island Countertop\r\n3. Edge Profile\r\n4. Sink\r\n5. Stove\r\n\n\nYour task is to generate a single natural language prompt for OpenAI’s `/v1/images/edits` (DALL·E inpainting API). Describe each feature’s visual style based on the corresponding image (e.g., material, color, texture). Instruct DALL·E to replace the matching feature in a kitchen photo using those styles. Do not explain anything or include a list — just return the final natural prompt DALL·E should use.",
  //   resultImageUrl : "https://ai-visualizing.s3.amazonaws.com/image-246030-c61414ca-445f-4814-aac5-c3946ab33f02.png",
  //   secondPrompt : "Replace the kitchen backsplash with a marble style featuring gray and white veining, use a sleek gray polished surface for the center island countertop, apply a smooth blue-gray stone with subtle striping for the edge profile, install a modern white double-basin farmhouse sink, and update the stove to a stainless steel design with digital controls and a large glass oven door."
  // },
  aiResults: [{
    id: 1,
    isActive: true,
    // conversionError: "Some error text",
    // sourceImageUrl: "localBlobUrl",
    // resultImageUrl : "https://ai-visualizing.s3.amazonaws.com/image-246030-83282aae-89fd-49e0-a465-15f2323ed9c5.jpg",
  }, {
    id: 2,
    // resultImageUrl : "https://ai-visualizing.s3.amazonaws.com/image-246030-e6b7da98-4e39-4bc7-85ca-1bda9328726c.png",
  }, {
    id: 3,
    // resultImageUrl : "https://ai-visualizing.s3.amazonaws.com/image-246030-c61414ca-445f-4814-aac5-c3946ab33f02.png",
  }],
  aiUserFileBlobUrl: "",
  lookAiVisited: false,
  lookAiImageOpened: false,
  lookAiRenderFinished: false,
  lookAiIntroOpened: false,
  lookAiWaitingBoxClicked: !!IS_QKB_UI,
  aiImageExpanded: false,
  aiExportData: {}, // is used to export data to local storage and job data
  aiImportData: {}, // is used to import data from local storage and job data, then it will be applied to the state (on content open)
  aiWaitingId: null,
  aiEnableReferenceImage: false,
  aiEnableThumbnailImages: true,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_AI_WAITING_ID:
    case types.SET_AI_USER_FILE_BLOB_URL:
    case types.SET_LOOK_AI_IMAGE_OPENED:
    case types.SET_LOOK_AI_RENDER_FINIHSED:
    case types.SET_LOOK_AI_WAITING_BOX_CLICKED:
    case types.SET_LOOK_AI_IMAGE_EXPANDED:
    case types.SET_LOOK_AI_EXPORT_DATA:
    case types.SET_LOOK_AI_IMPORT_DATA:
    case types.SET_AI_DISABLE_REFERENCE_IMAGE:
    case types.SET_AI_ENABLE_THUMBNAIL_IMAGES:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_AI_LOADING: {
      if (!action.payload.aiLoading && state.aiWaitingId) {
        state.aiWaitingId = null;
        setLocalStorageItem("aiWaitingId", "");
      }
      return Object.assign({}, state, {
        ...action.payload
      });
    }
    case types.SET_AI_RESULTS:
      return Object.assign({}, state, {
        ...action.payload,
        aiExportData: getExportAIData(state, null, action.payload.aiResults)
      });
    case types.SET_LOOK_OVERLAY_OPENED:
      if (action.payload && (action.payload.lookOverlayOpened === LOOK_OVERLAYS.aiPanel)) {
        let updatedState = {};
        if (!state.lookAiVisited) {
          updatedState.lookAiVisited = true; // allow rendering dom
        }
        if (state.lookAiRenderFinished) {
          updatedState.lookAiRenderFinished = false; // close sidebar popper
        }
        return Object.assign({}, state, updatedState);
      } else if (state.aiLoading && !state.lookAiWaitingBoxClicked) {
        return Object.assign({}, state, {
          lookAiWaitingBoxClicked: true, // hide waiting box if we closed ai popup
        });
      }
      break;
  }

  return state;

}
